<header role="banner">
  <div class="logo">
    <img [src]='logoSrc' [alt]='logoAlt'>
  </div>
  <span class="title">
    {{ 'DIPRSRegistration.header.title.part1' | translate }}
  </span>
  <span class="td-icon td-icon-colour-primary icon-small td-icon-secureBtn" aria-hidden="true"></span>
</header>
